import clsx from "clsx";
import { InfoIcon } from "components/InfoIcon";
import { bool, string } from "prop-types";

import classes from "./InfoLabel.module.scss";

const InfoLabel = ({ className, text, tooltipText, bold }) => {
  return (
    <div
      className={clsx(classes.infoLabel, className)}
      data-testid="info-label"
    >
      <span className={clsx({ [classes.bold]: bold })}>{text}</span>
      <InfoIcon tooltipText={tooltipText} />
    </div>
  );
};

InfoLabel.propTypes = {
  className: string,
  text: string.isRequired,
  tooltipText: string.isRequired,
  bold: bool,
};

export default InfoLabel;
